import MonitorForms from './MonitorForms';

/*
 * Model class Monitoring
 */
export default class Monitoring extends MonitorForms {
	constructor($http, $customer, $content, $mobile, $sce, $home_address_order, $form_details, $member_id) {
		super($http, $customer, $content, $mobile, $home_address_order, $member_id);

		this.forms = [];

        for (var detail in $form_details) {
        	this.forms.push({
                name 	: $content[$form_details[detail]['name']],
                alias 	: $form_details[detail]['alias'],
                fkey 	: $form_details[detail]['fkey'],
                icon	: $form_details[detail]['icon'],
                count 	: 0,
                fields 	: []
			});
        }
	}

	checkDOBFormat($string) {

	}

	getMonitoredDetails() {
		return new Promise((resolve, reject)=> {
			$.post('/user/portal/get_monitored_details/', {data: 'Show this now'}, function(data){
				resolve(data);
			});
		});
	}

	getIdentityRiskDetails() {
		return new Promise((resolve, reject)=>{
			$.get('/user/get-risk-details', function(data){
				resolve(data);
			});
		});
	}

	getAssetData() {
		return new Promise((resolve, reject)=>{
			$.get('/user/get-asset-data', (data)=>{
				for (var i in data) {
					for (var key in this.forms) {
						if (this.forms[key].fkey == i) {
							var data_count = {};

							for (var k in data[i]) {
								if (data_count[data[i][k].sd_id] === undefined) {
									data_count[data[i][k].sd_id] = 0;
								}

								data_count[data[i][k].sd_id] += 1;
							}

                            this.forms[key].count = Object.keys(data_count).length;

							if (data[i].length > 0) {
								for (var fkey in data[i]) {
									if (this.forms[key].fields[data[i][fkey].sd_id] === undefined) {
                                        this.forms[key].fields[data[i][fkey].sd_id] = [];
									}

									for (var f in data[i][fkey]) {
                                        this.forms[key].fields[data[i][fkey].sd_id][f] = data[i][fkey][f];
									}
								}
							}
						}
					}
				}

				resolve({
					forms: this.forms,
					risk_details: data.risk_details,
					monitor_details: data.monitor_details
				});
			});
		});
	}

	addAssetData(post_details) {
		return new Promise((resolve, reject)=>{
			$.post('/user/add-asset-data', post_details, function(data){
				resolve(data);
			});
		});
	}

	updateAssetData(post_details) {
		return new Promise((resolve, reject)=>{
			$.post('/user/update-asset-data', post_details, function(data){
				resolve(data);
			});
		});
	}

	deleteAssetData(post_details) {
		return new Promise((resolve, reject)=>{
			$.post('/user/delete-asset-data', post_details, function(data){
				resolve(data);
			});
		});
	}

    updateScanResultSurvive(post_details) {
	    return new Promise((resolve, reject)=>{
            $.post('/user/update_scan_result_survive', post_details, function(data){
                resolve(data);
            });
        });
    }

    ignoreScanRecord(post_details) {
        return new Promise((resolve, reject)=>{
            $.post('/user/ignore_scan_record/', post_details, function(data){
                resolve(data);
            });
        });
    }

	getScanData() {
		return new Promise((resolve, reject)=>{
			$.get('/user/portal/get_scan_data/', function(data){
				resolve(data);
			});
		});
	}

	add_edit_forms(index = undefined) {
		if (index !== undefined) {
			return this.forms[index];
		}

		return this.forms;
	}

	monitoring_page() {

	}

	download_page() {

	}

	faqs_page() {

	}

	personal() {

	}

	financial() {
		return `<div>
					<div class="flaticon-letter-x primary-blue-color"></div>
					<h3>Add/Edit Your Financial Details</h3>
					<p>We keep a close watch on bank account and card numbers to help keep them for your eyes only.</p>
					<h4 class="col-md-10">Credit Card Numbers</h4>
					<div class="row">
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Card Type</label>
								<input type="text" class="form-control" name="card_type" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Card Number</label>
								<input type="text" class="form-control" name="card_number" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Expirey Date</label>
								<input type="text" class="form-control" name="expirey_date" value="" />
							</div>
						</div>
					</div>
				</div>`;
	}

	contact() {
		return `<div>
					<div class="flaticon-letter-x primary-blue-color"></div>
					<h3>Add/Edit Your Contact Details</h3>
					<h4 class="col-md-10">Home Address</h4>
					<div class="row">
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>House Number</label>
								<input type="text" class="form-control" name="house_number" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Street Name</label>
								<input type="text" class="form-control" name="street_name" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Additional Address</label>
								<input type="text" class="form-control" name="additional_address" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>City</label>
								<input type="text" class="form-control" name="city" value="" />
							</div>
						</div>
						<div class="form-group col-md-6">
							<div class="col-md-10">
								<label>Post Code</label>
								<input type="text" class="form-control" name="post_code" value="" />
							</div>
						</div>
					</div>
				</div>
				<h4 class="col-md-10">Email Accounts</h4>
				<div class="row">
					<div class="form-group col-md-6">
						<div class="col-md-10">
							<label>Email Address 1</label>
							<input type="text" class="form-control" name="email_address_1" value="" />
						</div>
					</div>
				</div>
				<h4 class="col-md-10">Phone Number</h4>
				<div class="row">
					<div class="form-group col-md-6">
						<div class="col-md-10">
							<label>Landline</label>
							<input type="text" class="form-control" name="landline" value="" />
						</div>
					</div>
					<div class="form-group col-md-6">
						<div class="col-md-10">
							<label>Mobile</label>
							<input type="text" class="form-control" name="mobile" value="" />
						</div>
					</div>
				</div>`;
	}
}
